import { NgModule } from '@angular/core';

import { DropdownActionsFilterPipe } from './dropdown-actions-filter.pipe';

@NgModule({
    declarations: [DropdownActionsFilterPipe],
    exports: [DropdownActionsFilterPipe],
})
export class DropdownActionsFilterPipeModule {}
